export default [
    {
        path: '/token-management',
        component: () => import('./list.vue'),
        name: 'Supports'
    },
    {
        path: '/token-management/report-an-issue',
        component: () => import('./CreateReport.vue'),
        name: 'AddIssues',
    },
    {
        path: '/token-management/report-an-issue/:id',
        component: () => import('./IssueDetails.vue'),
        name: 'IssueDetails',
        props: true
    },
    {
        path: '/token-management/report-an-issue/:id/edit',
        name: 'IssueEdit',
        component: () => import('./CreateReport.vue'),
        props: true
    }
]